import React from 'react';

const PendingApprovalBanner = ({ companyName }) => (
    <div className="bg-bluegray border-l-4 border-yellow-500 rounded-md p-4 mb-4">
        <h3 className="text-base font-semibold text-yellow-400 mb-2">Pending Approval</h3>
        <p className="text-sm text-lightgray mb-2">
            Your request to join <strong>{companyName}</strong> is pending approval from the company admin.
        </p>
        <p className="text-sm text-lightgray mb-2">
            The admin has been notified and will review your request. You will receive an email once a decision is made.
        </p>
        <p className="text-sm text-lightgray">
            In the meantime, your account is active but you won't have access to company data such as job posts, candidates, or credits until approved.
        </p>
    </div>
);

export default PendingApprovalBanner;
